import { type ReactElement, type ReactNode } from 'react'
import { cn } from '@util'
import { type DashboardWidget } from '@terros/common'
import { isFullRowFeedWidget } from '@front/model'

type Props = {
  widgets: DashboardWidget[]
  children: (widget: DashboardWidget) => ReactNode
}

/**
 * The feed's responsive grid: widgets pair up two per row on desktop and stack
 * on narrow screens. Line, goal and metric-heavy number widgets span the full
 * row; number, table and leaderboard widgets share a row. Rows follow the
 * configured widget order strictly — a full-row widget may leave the half row
 * before it half empty, which is fine.
 */
export function DashboardFeedGrid({ widgets, children }: Props): ReactElement {
  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
      {widgets.map((widget) => (
        <div className={cn('min-w-0', isFullRowFeedWidget(widget) && 'md:col-span-2')} key={widget.widgetId}>
          {children(widget)}
        </div>
      ))}
    </div>
  )
}
